/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { ProactiveChatNames } from '../../helpers/consts';
import { TContextProvider } from '@msdyn365-commerce-modules/chat';
import ProactiveChatTrigger from './proactive-chat-trigger';

/**
 * FromSpecificPageTrigger class - proactive chat is triggered if user has come from specific page (the one listed in config.proactiveOnFromSpecificPageList)
 */
class FromSpecificPageTrigger extends ProactiveChatTrigger {
    public async validate(): Promise<boolean> {
        let isValid = false;
        if (this.props.config.proactiveOnFromSpecificPageList) {
            this.props.context.telemetry.debug(
                `[${FromSpecificPageTrigger.name}] Number of items in user-defined list of 'From Specific Page' was '${this.props.config.proactiveOnFromSpecificPageList?.length}'.`
            );
            for (let i = 0; i < (this.props.config.proactiveOnFromSpecificPageList?.length || 0); i++) {
                const fromSpecificPageTrimmed: string = this.props.config.proactiveOnFromSpecificPageList[i].trim();
                this.props.context.telemetry.debug(
                    `[Chat][${FromSpecificPageTrigger.name}] Current page URL: '${window.document.referrer}'.`
                );
                this.props.context.telemetry.debug(
                    `[${FromSpecificPageTrigger.name}] Current item from user-defined list of 'From Specific Page': '${fromSpecificPageTrimmed}'.`
                );

                if (window.document.referrer.indexOf(fromSpecificPageTrimmed) > -1) {
                    isValid = true;
                    break;
                }
            }
        } else {
            this.props.context.telemetry.debug(
                `[Chat][${FromSpecificPageTrigger.name}] User-defined 'From Specific Page' list was undefined.`
            );
        }
        this.props.context.telemetry.debug(`[Chat][${FromSpecificPageTrigger.name}] Validation returning '${isValid}'.`);
        return isValid;
    }
    public getContextProvider(): TContextProvider {
        return () => {
            return {
                ...this.context,
                eCommerceCustIsProactiveChat: 'True',
                eCommerceCustProactiveType: ProactiveChatNames.FromSpecificPage,
                eCommerceCustProactiveCameFromPage: window.document.referrer
            };
        };
    }
    public getMessage(): string {
        // @TODO: Add message processing if needed
        return this.props.config.proactiveOnFromSpecificPageMessage || this.props.config.proactiveDefaultMessage;
    }
}

export default FromSpecificPageTrigger;
